import { User } from '@/models/user.model';


export const userPermissions = (user: User | undefined) => {
  return [...new Set(user?.roles?.flatMap((role) => role.permissions))];
};

